export default __webpack_public_path__ + "static/media/Couples Strengths Exploration.fa4e2f21.pdf";